import { useAtomValue } from "jotai";
import { mergeClass } from "../../utils";
import { Button } from "../Button";
import { DisplayValue } from "../DisplayValue";
import _ from "lodash";
import { usePublisher } from "./usePublisher";
import { publishGroups } from "./publishConfig";
import { useState } from "react";
import { Spinner } from "../Loader";
import { Banner } from "./PublishBanner";
import { getGroupDataFromModel } from "./utils";

const PublishBanner = ({
  appGroup,
}: {
  appGroup: keyof typeof publishGroups;
}): JSX.Element => {
  const [isPublishing, setIsPublishing] = useState<boolean>(false);
  const publishState = useAtomValue(publishGroups[appGroup].atom);
  const upToDate = publishState.lastchange === publishState.lastpublish;
  const publish = usePublisher(appGroup, setIsPublishing);
  const pgroup = publishGroups[appGroup];
  const consolidatedName =
    _.includes(pgroup.models, appGroup) ||
    _.includes(pgroup.singleItems, appGroup)
      ? `all_${appGroup}`
      : appGroup;
  const modelsAndSingleItems = [
    consolidatedName,
    ...publishGroups[appGroup].models,
    ...publishGroups[appGroup].singleItems,
  ];
  return (
    <Banner
      published={upToDate}
      isPublishing={isPublishing}
      handlePublishPressed={() => publish()}
      modelsAndSingleItems={modelsAndSingleItems}
    />
  );
};

const PublishBannerByModel = ({ modelName }: { modelName: string }) => (
  <PublishBanner
    appGroup={
      getGroupDataFromModel(modelName).group as keyof typeof publishGroups
    }
  />
);

const HomePublishSection = ({
  appGroup,
}: {
  appGroup: keyof typeof publishGroups;
}): JSX.Element => {
  const [isPublishing, setIsPublishing] = useState<boolean>(false);
  const publishState = useAtomValue(publishGroups[appGroup].atom);
  const upToDate = publishState.lastchange === publishState.lastpublish;
  const publish = usePublisher(appGroup, setIsPublishing);
  return (
    <div className="mt-2 text-sm">
      <DisplayValue name="Last Modified" value={publishState.lastchange} />
      <DisplayValue
        name="Last Published"
        value={publishState.lastpublish}
        className={
          upToDate ? "text-unpublishedHome font-bold" : "text-primaryColor"
        }
      />
      <Button
        className="text-sm mt-2 flex gap-2"
        disabled={isPublishing}
        onClick={() => publish()}
      >
        Publish changes {isPublishing && <Spinner />}
      </Button>
    </div>
  );
};

export { HomePublishSection, PublishBannerByModel, PublishBanner };
